import {Injectable} from '@angular/core';
import {Auslandsadresse, StammdatenAdresse, LaenderschluesselEnum} from '@nachdigal';
import {AbstractMapper} from '../../abstract.mapper';
import {laendercodeToLaenderschluesselMap} from '../laendercodeToLaenderschluesselMap';

@Injectable()
export class AuslandsadresseMapperService extends AbstractMapper<StammdatenAdresse, Auslandsadresse> {

  private static getLaenderschluessel(laenderCode: string): LaenderschluesselEnum {
    const laenderschluessel = laendercodeToLaenderschluesselMap.get(laenderCode);
    if (!laenderschluessel) {
      return null;
    }
    return laenderschluessel as LaenderschluesselEnum;
  }

  public mapArray(source: Array<StammdatenAdresse>): Array<Auslandsadresse> {
    return super.mapArray(source?.filter(value => value.typ === StammdatenAdresse.TypEnum.NUMBER_1));
  }

  public getMappedArrayDefaultIndex(source: Array<StammdatenAdresse>): number {
    return source.filter(value => value.typ === StammdatenAdresse.TypEnum.NUMBER_1)
      .findIndex(value => value.standard);
  }

  protected mapInternal(source: StammdatenAdresse): Auslandsadresse {

    if (source.typ !== StammdatenAdresse.TypEnum.NUMBER_1) {
      return undefined;
    }

    return {
      strasse: source.ausland.strasse,
      hausnummer: source.ausland.hausnummer,
      hausnummernzusatz: source.ausland.hausnummernzusatz,
      adressergaenzung: source.ausland.anschriftenzusatz,
      ort: source.ausland.ort,
      postleitzahl: source.ausland.postleitzahl,
      land: AuslandsadresseMapperService.getLaenderschluessel(source.ausland.land)
    };
  }
}
